import React from 'react';
import { usePrecalculationContext } from './context';
import { FieldsBuilder } from '../../../../libs/uiKit/fieldsBuilder';
import {Heading3, Heading4} from "../../../../libs/uiKit/globalStyles";
import Button from "../../../../libs/uiKit/button";
import {TrashIcon} from "../../../../icons/ui/Trash";
import {StyledSubjectHeader} from "../../createAgreement/pages/property/ui/styles";
import {RedTrashIcon} from "../../../../icons/ui/RedTrash";

const HouseInProgress: React.FC = () => {
	const { borrowersItems, borrowerForm, append, remove } = usePrecalculationContext();

    const coborrowerCaption = (index: number): string => {
        switch (index) {
            case 1:
                return 'Первый созаёмщик';
            case 2:
                return 'Второй созаёмщик';
            case 3:
                return 'Третий созаёмщик';
            case 4:
                return 'Четвёртый созаёмщик';
            case 5:
                return 'Пятый созаёмщик';
            case 6:
                return 'Шестой созаёмщик';
            default:
                return `Созаемщик №${index + 1}`;
        }
    }

	return (
		<>
			{borrowersItems.map(({ id, form }, index) => (
				<React.Fragment key={id}>
                    {index > 0 && <>
                        <StyledSubjectHeader style={{justifyContent: "left", marginBottom: "0"}}>
                            <Heading4>{coborrowerCaption(index)}</Heading4>
                            {index > 1 && <>
                                &nbsp;&nbsp;
                                <Button appearance='icon' onClick={(): void => remove(index)} icon={<RedTrashIcon />} />
                            </>}
                        </StyledSubjectHeader>
                    </>}
					<FieldsBuilder {...form} />
					{index === 0 && <FieldsBuilder {...borrowerForm} />}
				</React.Fragment>
			))}
            {borrowersItems.length > 1 && borrowersItems.length < 6 &&
                <Button
                    appearance="transparent"
                    style={{width: '24rem'}}
                    onClick={() => append({})}
                >Добавить созаёмщика</Button>
            }
		</>
	);
};

export default React.memo(HouseInProgress);
